<template>
  <div
    v-on:click="redirect"
    class="py-3 flex w-full"
    :class="{ 'border-b': show_border }"
  >
    <div class="flex w-full items-center"> 

      <div v-if="icon" class="w-icon h-icon mr-2 flex-shrink-0 flex items-center">
        <img :src="require('@/assets/icons/' + icon)" />
      </div>

      <div class="flex-grow flex flex-col w-full">
        
        <div class="flex items-center justify-between w-full min-w-0">

          <div
            class="text-md font-semibold pr-2 break-words whitespace-normal min-w-0"
          >
            <span v-text="title"></span>
          </div>

          <div class="flex items-center justify-end gap-2 flex-shrink-0">

            <span
              v-if="!$slots.default"
              class="text-sm truncate max-w-[140px]"
              v-text="value"
            ></span>

            <slot></slot>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-setting-card-item",
  props: {
    title: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    href: {
      type: String,
    },
    show_border: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    redirect() {
      if (this.href != null) {
        this.$router.push(this.href);
      }
    },
  },
};
</script>

<style scoped>
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
